import { createFileRoute } from '@tanstack/react-router'
import { CertificationHistoryPage } from '@/features/certification/pages/certification-history-page'

export const Route = createFileRoute('/_authenticated/_sidebar/observer/certification-history')({
  component: CertificationHistory,
})

function CertificationHistory() {
  return <CertificationHistoryPage />
}

